import {Button} from '@mui/material';
import React from 'react';

import {EmptySearchState} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {Loading} from 'presentation/components/Loading/Loading';
import {ExamEmptyStateProps} from './types';
import {useExamEmptyState} from './hooks/useExamEmptyState';
import {useQueryParams} from 'presentation/pages';
import {FeaturesEnum, QueryParamsEnum} from 'presentation/constants';
import {DefaultEmptyState} from 'presentation/components/DefaultEmptyState';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

const {noFilteredResults, emptyDescription, callToChat} = translations['pt-br'].commons;
const {emptyState} = translations['pt-br'].privateFlow.bookingFlow.examSelection;
const {consultNetworkProviderHealth} = translations['pt-br'].privateFlow.profile.locationSelection;

export function ExamEmptyState({dataTagId, options}: ExamEmptyStateProps) {
	const {
		SEARCH_PARAMS: {query},
		setSearchParams,
	} = useQueryParams();
	const {isEnabled: isOnDemandExamsEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_ON_DEMAND_EXAMS,
	);
	const {isMobile, callChatRoomIsLoading, handleCallChatRoom, handleGoToProcedureSelection} =
		useExamEmptyState();

	function handleRemoveFilter() {
		setSearchParams(prev => {
			prev.delete(QueryParamsEnum.SEARCH_QUERY);
			return prev;
		});
	}

	if (isOnDemandExamsEnabled && query) {
		return (
			<DefaultEmptyState
				title={noFilteredResults}
				description={emptyDescription}
				dataTagId={dataTagId}
				clearFilters={handleRemoveFilter}
				hasCallChatRoom
			/>
		);
	}

	return (
		<EmptySearchState
			title={options?.title || emptyState.title}
			description={options?.description || emptyState.description}
			dataTagId={dataTagId}
			hideImage={true}
			customMargin="initial"
			sx={{width: 'fit-content', textAlign: isMobile ? 'center' : 'left'}}>
			<Button
				size="large"
				onClick={options?.primaryButtonAction || handleGoToProcedureSelection}>
				{options?.primaryButtonText || consultNetworkProviderHealth}
			</Button>

			<Button
				variant="outlined"
				size="large"
				onClick={handleCallChatRoom}
				disabled={callChatRoomIsLoading}
				endIcon={callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null}>
				{callToChat}
			</Button>
		</EmptySearchState>
	);
}
